import { gql } from '@apollo/client';

export type AuthenticateUserType =
  | {
      token: string;
    }
  | null
  | undefined;

export type SET_USER_ACTIVE_ORGANISATIONType =
  | {
      authenticateUser: AuthenticateUserType;
    }
  | null
  | undefined;

export const SET_USER_ACTIVE_ORGANISATION = gql`
  mutation SetUserActiveOrganisation($input: SetUserActiveOrganisationInput!) {
    authenticateUser: setUserActiveOrganisation(input: $input) {
      token
    }
  }
`;
